import { Stack, Text } from '@repletoryreach/sdk-ui';
import { useT } from '../../../i18n/I18nProvider';
import { formatCount } from '../../../lib/format';
import { focusCounts } from '../lib/data';
import { MUTED, Muted, Panel, SeeChats, WholeReport } from '../shared';
import type { TabProps } from './tab';

/** The business's own questions: what the AI answered for the whole report, and how many of the chats shown say yes. */
export function Questions({ report, rows, onSee }: TabProps) {
  const t = useT();
  const answers = report.sections?.focus ?? [];
  if (report.focus.length === 0) return <Muted>{t('insights.questions.none')}</Muted>;
  return (
    <Stack gap="lg" data-testid="insights-questions">
      {report.focus.map((q, i) => {
        const a = answers.find((x) => x.question === q) ?? answers[i];
        const c = focusCounts(rows, i);
        return (
          <Panel key={i} title={q} note={<WholeReport t={t} />}>
            {a ? <Text role="bodySmall">{a.answer}</Text> : <Muted>{t('insights.questions.noAnswer')}</Muted>}
            <Text role="caption" c={MUTED}>
              {t('insights.questions.counts', { yes: formatCount(c.yes), no: formatCount(c.no), unclear: formatCount(c.unclear) })}
            </Text>
            <SeeChats refs={c.refs.length ? c.refs : a?.refs ?? []} onSee={onSee} t={t} />
          </Panel>
        );
      })}
    </Stack>
  );
}
